module.exports = __webpack_public_path__ + "img/brand-cases28.0b1e524b.png";